module.exports = {
      id: "protichinta-usage",
      viewBox: "0 0 192 60",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#protichinta",
      toString: function () {
        return this.url;
      }
    }